const formatEuro = ( price ) => {

    let euro = Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        useGrouping: true
    });

    return euro.format(price);
};

const formatPct = ( num ) => {

    let numFormat = Intl.NumberFormat('es-ES', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const pct = numFormat.format(num/100);
    return pct;
};

export { formatEuro, formatPct };